export const STORE_KEY = 'credits';
